import { useQuery } from '@apollo/client';
import { storeIdSearchQuery } from '@/graphql/queries';

/**
 * When a user lands on /partner/store/:storeId directly (bookmark, legacy link,
 * etc.) we don't have the surrounding search context that would normally carry
 * the `brand_id` needed by MerchantStorePage. This hook resolves that by
 * fetching the store and returning its brand_id.
 */
export function useResolveStoreBrand(storeId: string | undefined) {
  const { data, loading } = useQuery(storeIdSearchQuery, {
    variables: { id: storeId },
    skip: !storeId,
    fetchPolicy: 'cache-first',
  });
  const brandId: string | undefined = data?.store?.brand_id ?? undefined;
  return { brandId, loading };
}
